export default __webpack_public_path__ + "static/media/Manhattan-Whoosit-Water-Mat-1.bcde7acf.jpg";